// src/lib/proposalExclusion.js
// Les œuvres d'une proposition d'acquisition (collection_type = 'proposal') sont de vraies lignes `artworks`
// du conseiller, mais elles ne lui appartiennent pas : elles ne doivent entrer ni dans ses totaux, ni dans ses
// assurances, ni dans ses transmissions, ni dans ses exports, ni dans ses alertes.
// Les écrans qui lisent « toutes les œuvres de l'utilisateur » appliquent donc ce filtre (côté base, pour que
// les compteurs et la pagination restent justes). Les écrans qui lisent une collection précise n'en ont pas besoin.
import { supabase } from "./supabaseClient";

const TTL_MS = 30000;
const cache = new Map(); // uid -> { at, ids }

// Identifiants des collections « proposal » visibles par l'utilisateur (la politique d'accès ne montre que les siennes).
export async function proposalCollectionIds(uid) {
  if (!uid) return [];
  const hit = cache.get(uid);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.ids;
  const { data, error } = await supabase.from("collections").select("id").eq("collection_type", "proposal");
  const ids = error ? [] : (data || []).map((c) => c.id).filter(Boolean);
  if (!error) cache.set(uid, { at: Date.now(), ids });
  return ids;
}

export function clearProposalCollectionCache() { cache.clear(); }

// Ajoute le filtre à une requête sur `artworks` / `artworks_secure`. Les œuvres sans collection restent incluses
// (un simple « not in » les écarterait, car NULL n'est jamais « not in »).
export function applyProposalFilter(query, ids) {
  if (!ids || ids.length === 0) return query;
  return query.or(`collection_id.is.null,collection_id.not.in.(${ids.join(",")})`);
}

// Variante pour une requête complète : `await withoutProposalWorks(supabase.from("artworks").select(...).eq(...), uid)`
export async function withoutProposalWorks(query, uid) {
  return applyProposalFilter(query, await proposalCollectionIds(uid));
}
